module.exports = __webpack_public_path__ + "assets/img/shuiyin-yigoumai.f7f6d4f2.png";